import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import DiamondLinksEmailTemplateService from "../../../services/diamondLinks-emailTemplate.service";
import { Button, Modal, Spin, Tooltip } from "antd";


export const PendantBuilderEmailTemplate = (props) => {
  const { t } = useTranslation();
  const [typeName, setTypeName] = useState(null);
  const [visible, setVisible] = useState(false);
  /*API Binding Starts*/

  //Dropdown List Starts
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [dealerId, setDealerId] = useState(0);
  const [relaod, setReload] = useState(false);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setDealerId(loginDetials.responseData.dealerId);
      }
    }
  }, []);

  //Dropdown List Ends

  const handleEmailUpdate = () => {
    handleUpdateDiamondLinkEmailTemplateDetails(
      loginDetials.responseData.dealerId
    );
  };

  const refreshPage = () => {
    setVisible(false);
    setReload(!relaod);
  };

  const handleGetDiamondEmailTemplatesDetails = (name, id) => {
    try {
      let inputData = {
        dealerID: dealerId || id,
        typeName: name,
      };
      setContent("");
      setVisible(true);
      setTypeName(name);
      setLoading(true);
      DiamondLinksEmailTemplateService.GetDiamondEmailTemplatesDetails(
        inputData
      )
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setContent(responseData[0].emailContent);
              setLoading(false);
            } else {
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("uploadImg", file);
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const handleUpdateDiamondLinkEmailTemplateDetails = (id) => {
    try {
      let inputData = {
        dealerID: dealerId || id,
        typeName: typeName,
        emailContent: content,
      };
      DiamondLinksEmailTemplateService.UpdateDiamondLinkEmailTemplateDetails(
        inputData
      )
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(
              t("Email template has been saved successfully.")
            );
          } else {
            NotificationManager.error(
              t("Email template has not been updated.")
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*API Binding Ends*/

  return (
    <div className="form__fields">
      <div className="row">
        <div className="col-md-12">
          <h4 className="workarea__heading mt-0">
            {" "}
            {""} {t("Pendant Builder Emails")} {""}{" "}
          </h4>
        </div>
      </div>

      <div className="emailTemplate">
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Diamond Request More Info")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBDiamondToRetailerInquires"
                      )
                    }
                  >
                    {""} {t("Send Mail to Retailer")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBDiamondToSenderInquires"
                      )
                    }
                  >
                    {""} {t("Send Mail to Sender")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Request More Info")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToRetailerInquires"
                      )
                    }
                  >
                    {""} {t("Send Mail To Retailer")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToSenderInquires"
                      )
                    }
                  >
                    {""} {t("Send Mail to Sender")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Email To Friend")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("PBToFriendEmailF")
                    }
                  >
                    {t("Send Mail to Friend")}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToRetailerEmailF"
                      )
                    }
                  >
                    {""} {t("Send Mail To Retailer")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails("PBToSenderEmailF")
                    }
                  >
                    {""} {t("Send Mail to Sender")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Drop A Hint")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToRecipientDropAHint"
                      )
                    }
                  >
                    {""} {t("Send Mail to Recipient")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToRetailerDropAHint"
                      )
                    }
                  >
                    {""} {t("Send Mail to Retailer")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="emailDetailBlock">
              <h1>
                {" "}
                {""} {t("Schedule View")} {""}{" "}
              </h1>
              <ul>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToScheduleViewDiamondDetail"
                      )
                    }
                  >
                    {""} {t("Diamond Detail")} {""}{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={() =>
                      handleGetDiamondEmailTemplatesDetails(
                        "PBToScheduleViewComplete"
                      )
                    }
                  >
                    {""} {t("Complete Pendant Setting")} {""}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 mb-4">
            <h1 className="request-diamond-sp mb-3">
              {" "}
              {""} {t("Request A Diamond Email")} {""}{" "}
            </h1>
            <div className="emailDetailBlock">
              <ul>
                <li>
                  <h2>
                    {" "}
                    {""} {t("Request A Diamond")} {""}{" "}
                  </h2>
                  <ul>
                    <li>
                      <Link
                        to=""
                        onClick={() =>
                          handleGetDiamondEmailTemplatesDetails(
                            "PBToRequestADiamond"
                          )
                        }
                      >
                        {" "}
                        {""} {t("Send Mail to Request A Diamond")} {""}{" "}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="emailTemplateEditorModal"
        title={t("Send Email")}
        centered
        visible={visible}
        onOk={() => {
          setVisible(false);
          handleEmailUpdate();
        }}
        onCancel={refreshPage}
        width={800}
        hieght={600}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={refreshPage}>
            {t("Cancel")}
          </Button>,
          <Button
            className="primary-btn"
            onClick={() => {
              setVisible(false);
              handleEmailUpdate();
            }}
          >
            {t("Save")}
          </Button>,
        ]}
      >
        <div className="editor__section">
          <Spin spinning={loading}>
            <CKEditor
              key={relaod}
              config={{
                extraPlugins: [uploadPlugin],
              }}
              editor={ClassicEditor}
              data={content ? content : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                setContent(data);
              }}
            />
          </Spin>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendantBuilderEmailTemplate);
